import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheck, FiArrowDown } = FiIcons;

const OfferStack = () => {
  const items = [
    { label: "Conversion copywriting", value: "$600" },
    { label: "Trade-specific design", value: "$800" },
    { label: "Local SEO foundation", value: "$450" },
    { label: "Enquiry capture setup", value: "$250" },
    { label: "Mobile optimisation", value: "$400" }
  ];

  return (
    <section id="offer-stack" className="py-20 bg-black border-y border-white/5">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.25 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl lg:text-4xl font-bold text-white">
            Everything Included, Built to Convert
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.98 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.2 }}
          viewport={{ once: true }}
          className="bg-white/5 backdrop-blur-sm border border-white/20 rounded-3xl overflow-hidden shadow-2xl"
        >
          <div className="grid md:grid-cols-2">
            {/* Left Column: List */}
            <div className="p-8 lg:p-10 border-b md:border-b-0 md:border-r border-white/10">
              <h3 className="text-xl font-bold text-white mb-6">The Inclusions</h3>
              <ul className="space-y-4">
                {items.map((item, i) => (
                  <li key={i} className="flex items-center gap-3">
                    <div className="bg-green-500/20 p-1 rounded-full">
                      <SafeIcon icon={FiCheck} className="w-3 h-3 text-green-400" />
                    </div>
                    <span className="text-white/80 font-medium">{item.label}</span>
                  </li>
                ))}
                <li className="pt-4 mt-4 border-t border-white/10 flex items-center gap-3">
                  <div className="bg-blue-500/20 p-1 rounded-full">
                    <SafeIcon icon={FiCheck} className="w-3 h-3 text-blue-400" />
                  </div>
                  <span className="text-blue-300 font-semibold italic">3 months hosting + email included</span>
                </li>
              </ul>
            </div>

            {/* Right Column: Values */}
            <div className="p-8 lg:p-10 bg-white/[0.02] flex flex-col justify-center">
              <div className="space-y-3 mb-8">
                {items.map((item, i) => (
                  <div key={i} className="flex justify-between text-sm">
                    <span className="text-white/40">{item.label}</span>
                    <span className="text-white/40">{item.value}</span>
                  </div>
                ))}
                <div className="pt-3 border-t border-white/10 flex justify-between">
                  <span className="text-white/60 font-bold">Total typical value</span>
                  <span className="text-white/60 font-bold">$2,500+</span>
                </div>
              </div>

              <div className="text-center p-6 bg-gradient-to-br from-blue-500/10 to-purple-600/10 rounded-2xl border border-white/10">
                <p className="text-white/60 text-sm mb-1 uppercase tracking-widest font-bold">Your Investment</p>
                <p className="text-4xl lg:text-5xl font-bold text-white">$897</p>
                <div className="inline-flex items-center gap-2 mt-4 text-green-400 text-sm font-bold">
                  <SafeIcon icon={FiArrowDown} className="animate-bounce" />
                  <span>Save over $1,600 today</span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default OfferStack;